import { ProductNew } from '../types';

export const MOCK_PRODUCTS: readonly ProductNew[] = [
  {
    id: '1',
    warehouse_id: '1',
    contractor_id: '4',
    contract_id: '4',
    category_id: '1',
    is_service: false,
    code: 'BRD001',
    name: 'Хлеб белый нарезной',
    description: 'Хлеб белый высшего сорта, нарезной 500г',
    count_value: 150,
    count_metric: 'шт',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '2',
    warehouse_id: '2',
    contractor_id: '1',
    contract_id: '1',
    category_id: '2',
    is_service: false,
    code: 'MLK001',
    name: 'Молоко пастеризованное',
    description: 'Молоко пастеризованное 3.2% жирности 1л',
    count_value: 50,
    count_metric: 'л',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '3',
    warehouse_id: '2',
    contractor_id: '3',
    contract_id: '3',
    category_id: '3',
    is_service: false,
    code: 'MEA001',
    name: 'Говядина охлаждённая',
    description: 'Говядина охлаждённая высшего сорта',
    count_value: 25.5,
    count_metric: 'кг',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '4',
    warehouse_id: '1',
    contractor_id: '2',
    contract_id: '2',
    category_id: '4',
    is_service: false,
    code: 'VEG001',
    name: 'Картофель',
    description: 'Картофель столовый отборный',
    count_value: 100,
    count_metric: 'кг',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '5',
    warehouse_id: '1',
    contractor_id: '1',
    contract_id: '1',
    category_id: '4',
    is_service: false,
    code: 'VEG002',
    name: 'Морковь',
    description: 'Морковь столовая свежая',
    count_value: 80,
    count_metric: 'кг',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  },
  {
    id: '6',
    warehouse_id: '1',
    contractor_id: '2',
    contract_id: '2',
    category_id: '1',
    is_service: false,
    code: 'BRD002',
    name: 'Батон нарезной',
    description: 'Батон нарезной из пшеничной муки 400г',
    count_value: 75,
    count_metric: 'шт',
    created_at: new Date('2024-01-01').toISOString(),
    is_deleted: false
  }
] as const;
